import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { connect, ConnectedProps } from 'react-redux'

import protocolsService from '../../../services/protocols.service';

import {
    IChoiceField,
    IDateTimeField,
    IField, IFilterEF, INumberField, IProtocol, IQueryCriteriaEF, ISortEF
} from '../../../shared/interfaces';
import {
    IProtocolsSearchPageResult
} from '../../../shared/interfacesDTO';

import abilityBuild from '../../../shared/CASL/appAbility';
import { subject, Unsubscribe } from '@casl/ability';
import {
    Selection, DetailsList, DetailsListLayoutMode, IColumn, Icon, Text, IDetailsListStyles,
    IRenderFunction, Link, mergeStyleSets, MessageBarType, MessageBar, SelectionMode, CheckboxVisibility,
    TooltipHost, DetailsHeader, ContextualMenu, IContextualMenuItem, TooltipOverflowMode, ITooltipHostStyles,
    IDetailsColumnStyles, IDetailsColumnFieldProps, ICommandBarItemProps, CommandBar, IButtonProps,
    ICommandBarStyles, IDetailsRowStyles, IDetailsListProps, DetailsRow
} from '@fluentui/react';

import { reduxActions, RootState } from '../../../store';

import CircleLoader from '../../Loader/CircleLoader/CircleLoader';
import { FilterEF_Operator, Protocol_State, Protocol_State_Label, Protocol_Type, SortEF_Direction, Visibility_Type } from '../../../shared/enums';

import axios, { CancelTokenSource } from 'axios';
import AppUtilities from '../../../shared/Utilities/appUtilities';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomCommandBarButton from '../../CustomFluentUI/CustomCommandBarButton/CustomCommandBarButton';
import CustomCommandBarMenuItem from '../../CustomFluentUI/CustomCommandBarMenuItem/CustomCommandBarMenuItem';
import TableIconProprietario from '../../../sharedComponents/TableIconProprietario';
import TableIconInoltro from '../../../sharedComponents/TableIconInoltro';
import TableIconCopiaConoscenza from '../../../sharedComponents/TableIconCopiaConoscenza';
import TableIconVisibilita from '../../../sharedComponents/TableIconVisibilita';

import { myTheme } from '../../../assets/styles/my-theme';
import SearchPanel from '../../../sharedComponents/Panels/SearchPanel';
import { toastRef } from '../../Layout/Layout';
import SummaryIACallout from '../../../sharedComponents/SummaryIACallout';

const { fonts } = myTheme;

const classNames = mergeStyleSets({
    fileIconHeaderIcon: {
        padding: 0,
        fontSize: '16px',
    },
    fileIconCell: {
        textAlign: 'center',
        selectors: {
            '&:before': {
                content: '.',
                display: 'inline-block',
                verticalAlign: 'middle',
                height: '100%',
                width: '0px',
                visibility: 'hidden',
            },
        },
    },
    fileIconImg: {
        verticalAlign: 'middle',
        maxHeight: '16px',
        maxWidth: '16px',
    },
    controlWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    exampleToggle: {
        display: 'inline-block',
        marginBottom: '10px',
        marginRight: '30px',
    },
    selectionDetails: {
        marginBottom: '20px',
    },
    tableIcons: {
        fontSize: '1.5em'

    },
    defaultField: {
        display: 'flex',
        alignItems: 'center'
    },
    iconField: {
        padding: '5px',
        width: '28px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'


    },
    iconFieldHeader: {
        padding: 0,
        fontSize: '16px',
    },
    filtriCommandBar: {
        paddingTop: '20px'
    },
    xSmallText: {
        fontSize: fonts.xSmall.fontSize,
    },
    emptyColumn: {}

});

const overflowProps: IButtonProps = {
    menuProps: {
        contextualMenuItemAs: CustomCommandBarMenuItem,
        items: []
    },
};

const filtriCommandBarStyles: Partial<ICommandBarStyles> = {
    root: { padding: '0 24px', borderBottom: '1px solid #eee' }

}
const tooltipHostStyles: Partial<ITooltipHostStyles> = {
    root: {
        display: 'inline-block',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'

    }
};


const detailsListStyles: Partial<IDetailsListStyles> = {
    root: {
        overflow: 'visible',
    },
}

const iconHeaderStyles: Partial<IDetailsColumnStyles> = {
    root: {
        width: '28px !important',
        padding: 0
    },
    cellTitle: {
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0
    }

}

const initialSearchFields: IField[] = [
    {
        decimals: 0,
        percentage: false,
        displayName: "Numero protocollo",
        internalName: "NumeroProtocollo",
        sharepointType: "Number",
        controlType: "textbox",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false
    } as INumberField,
    {
        dateOnly: true,
        displayName: "Data Protocollo",
        internalName: "DataProtocollo",
        sharepointType: "Date",
        controlType: "calendar",
        required: false,
        readonly: false,
        disabled: false,
        rangeMode: true,
        internalValue: "",
        valid: false,
        touched: false

    } as IDateTimeField,
    {
        displayName: "Tipo Protocollo",
        internalName: "TipoProtocollo",
        sharepointType: "Choice",
        controlType: "dropdown",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false,
        options: [
            { key: Protocol_Type.DocumentoInEntrata, text: "Documento in Entrata" },
            { key: Protocol_Type.DocumentoInUscita, text: "Documento in Uscita" },
            { key: Protocol_Type.DocumentoInterno, text: "Documento Interno" }
        ]

    } as IChoiceField,

    {
        displayName: "Oggetto Protocollo",
        internalName: "OggettoProtocollo",
        sharepointType: "Text",
        controlType: "textbox",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false

    }
];

const queryString = require('query-string');

const mapState = (state: RootState) => ({
    currentUser: state.sessionReducer.currentUser,
    currentUor: state.sessionReducer.currentUor,
    currentAoo: state.sessionReducer.currentAoo,
    tuttiIProtocolliViewFields: state.sessionReducer.tuttiIProtocolliViewFields,
    campiRicercaViewFields: state.sessionReducer.campiRicercaViewFields,
    isMobile: state.sessionReducer.isMobile
})
const mapDispatch = {
    setProtocol: (protocol: IProtocol) => (reduxActions.appNavigationActions.setProtocol(protocol)),
}


const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>

export interface ProtocolsTableState {
    columns: IColumn[];
    items: (IProtocol | null)[];
    totalCount: number;
    selectedProtocol?: IProtocol

    filtriCommandBarItems: ICommandBarItemProps[];

    isLoadingProtocols: boolean,

    messageBarIsVisible: boolean,
    messageBarType: MessageBarType | undefined,
    messageBarText: string

    showContextualMenu: boolean
    contextMenuItems: IContextualMenuItem[] | undefined
    contextMenuPosition: any

    queryCriteria: IQueryCriteriaEF

    activePanel: 'none' | 'search' | 'summaryIA'
    summaryIA: string | undefined
    isLoadingSummaryIA: boolean
    calloutTargetId: string | undefined
}
export interface ProtocolsTableProps {
    pageType: 'today' | 'acquired' | 'drafts';
    onSelectionChanged: (selectedProtocol?: IProtocol) => void;
    onDownloadProtocolDocumentClick: () => void;
    onDownloadAllButtonClick: () => void;
    showFilterCommandBar?: boolean
    forceTableRefresh?: boolean;
    deleteDraftHandler?: () => void;
    createProtocolFromHandler?: () => void;
}

type Props = ProtocolsTableProps & RouteComponentProps & PropsFromRedux

class ProtocolsTable extends React.Component<Props, ProtocolsTableState> {

    cancelTokenSources = {};
    unsubscribeFromAbility: Unsubscribe = () => { };
    private protocolSelection: Selection;
    private readonly EMPTY_VALUE = "-";

    constructor(props) {        super(props);

        this.protocolSelection = new Selection({
            onSelectionChanged: () => {
                const selection = this.protocolSelection.getSelection()[0] as IProtocol;
                this.setState({ selectedProtocol: selection });
                this.props.onSelectionChanged(selection);
            },
        });


        this.state = {
            columns: [],
            items: [],
            totalCount: 0,
            filtriCommandBarItems: [],

            isLoadingProtocols: true,

            messageBarIsVisible: false,
            messageBarType: undefined,
            messageBarText: '',

            showContextualMenu: false,
            contextMenuItems: [],
            contextMenuPosition: undefined,

            queryCriteria: { pageNumber: 1, filters: [], sorts: [] },
            activePanel: 'none',
            summaryIA: undefined,
            isLoadingSummaryIA: false,
            calloutTargetId: undefined
        };
    }


    componentDidMount() {
        // Mi sottoscrivo all'aggiornamento dell'ability: se le colonne vengono costruite
        // prima che l'ability sia pronta, la colonna hasSummaryIAIcon (pagina bozze) potrebbe mancare.
        this.unsubscribeFromAbility = abilityBuild.on('updated', this.ensureSummaryIAColumn);
        /// currentAoo è già valorizzate al mount quando faccio routing da una 
        /// pagina qualsiasi verso una contenente ProtocolsTable
        if (this.checkUor() && this.props.currentAoo && this.props.tuttiIProtocolliViewFields) {
            let columns = this.setColumns();

            let initQueryCriteria = this.resolveInitQueryCriteria();


            this.setState({
                columns,
                items: [],
                queryCriteria: initQueryCriteria,
                isLoadingProtocols: true,
            }, () => { this.getProtocolli() });

        }
    }


    componentDidUpdate(oldProps: Props, oldState: ProtocolsTableState) {
        /// dopo il refresh pagina currentUor passa da undefined a valorizzato
        /// oppure se cambio uor
        if (this.checkUor() &&
            ((oldProps.currentUor !== this.props.currentUor && this.props.tuttiIProtocolliViewFields)
                || (this.props.currentUor && !oldProps.tuttiIProtocolliViewFields && this.props.tuttiIProtocolliViewFields))) {
            let columns = this.setColumns();
            let initQueryCriteria = this.resolveInitQueryCriteria();
            this.setState({
                columns,
                isLoadingProtocols: true,
                items: [],
                queryCriteria: initQueryCriteria,
            }, () => { this.getProtocolli() });
        }
        if (oldProps.forceTableRefresh !== this.props.forceTableRefresh) {
            this.setState({
                items: []
            }, () => { this.getProtocolli() });
            this.protocolSelection.setItems([]);
        }
    }

    componentWillUnmount() {

        // cancello tutte le request in pending
        for (const [key, value] of Object.entries<CancelTokenSource>(this.cancelTokenSources)) {
            value.cancel(`${key} canceled`)
        }

        this.unsubscribeFromAbility();

    }

    // Garantisce la presenza della colonna hasSummaryIAIcon quando l'ability viene aggiornata
    // dopo la costruzione iniziale delle colonne (solo per la pagina bozze).
    ensureSummaryIAColumn = () => {
        const canUseIA = abilityBuild.can('use', subject('IFeature', { key: 'IAAssistant', enabled: true }));
        const hasColumn = this.state.columns.some((col: IColumn) => col.key === 'hasSummaryIAIcon');
        if (this.props.pageType === 'drafts' && canUseIA && !hasColumn && this.props.tuttiIProtocolliViewFields) {
            this.setState({ columns: this.setColumns() });
        }
    }
    resolveInitQueryCriteria = (): IQueryCriteriaEF => {
        let filters: IFilterEF[] = [];
        let sorts: ISortEF[] = [];


        switch (this.props.pageType) {
            case 'today':
                let today = new Date();
                let dateOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0);
                filters.push({
                    internalName: "DataProtocollo",
                    value: [dateOnly],
                    operator: FilterEF_Operator.Equals
                })
                break;
            case 'acquired':
                filters.push({
                    internalName: "StatoProtocollo",
                    value: [Protocol_State.Allocato, Protocol_State.Acquisito],
                    operator: FilterEF_Operator.Equals
                })
                break;
            case 'drafts':
                filters.push({
                    internalName: "StatoProtocollo",
                    value: [Protocol_State.InCreazione, Protocol_State.InCreazioneDaMail],
                    operator: FilterEF_Operator.Equals
                });
                sorts.push({
                    fieldName: "Id",
                    sortDirection: SortEF_Direction.Descending
                }); break;
        }

        return { pageNumber: 1, filters: [...filters], sorts: [...sorts] };
    }
    onRenderMissingItem = (): null => {
        if (this.state.isLoadingProtocols) {
            return null;
        }

        let currentItems = this.state.items.slice();
        currentItems.pop();

        this.setState({
            items: currentItems
        }, () => {
            this.getProtocolli();
        });

        return null;
    };

    getProtocolli = () => {
        const { location, match } = this.props;
        let aooId: number = Number(match.params['aooId']);
        const parsedQueryString = queryString.parse(location.search);
        let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

        if (aooId && uorId) {


            // se in cancelTokenSources c'è il cancelToken associato alla chiamata
            // chiamo il metodo cancel che interrompe la chiamata in pending
            this.cancelTokenSources[protocolsService.getProtocolsUor.name]?.cancel(protocolsService.getProtocolsUor.name + " Request annullata");
            // Ricreo il cancel token ad ogni request
            this.cancelTokenSources[protocolsService.getProtocolsUor.name] = axios.CancelToken.source();


            this.setState({ isLoadingProtocols: true })
            let { queryCriteria, totalCount } = this.state;

            protocolsService.getProtocolsUor(aooId, uorId, queryCriteria, this.cancelTokenSources[protocolsService.getProtocolsUor.name].token)
                .then((result: IProtocolsSearchPageResult) => {
                    const pageItems = result.items ?? [];
                    const newTotalCount = result.totalCount ?? totalCount;

                    const currentItems = this.removeNullPlaceholders(this.state.items);

                    const mergedItems: (IProtocol | null)[] = [...currentItems, ...pageItems];
                    const nextPageNumber = queryCriteria.pageNumber + 1;

                    if (mergedItems.length < (newTotalCount ?? 0)) {
                        mergedItems.push(null);
                    }

                    this.setState(prevState => ({
                        messageBarIsVisible: false,
                        items: mergedItems,
                        totalCount: newTotalCount ?? 0,
                        queryCriteria: {
                            ...prevState.queryCriteria,
                            pageNumber: nextPageNumber
                        },
                        isLoadingProtocols: false
                    }));



                    delete this.cancelTokenSources[protocolsService.getProtocolsUor.name];
                })
                .catch(error => {
                    if (axios.isCancel(error)) {
                        //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                        console.log(error.message);
                    }

                    this.setState({
                        isLoadingProtocols: false,
                        messageBarIsVisible: true,
                        messageBarType: MessageBarType.error,
                        messageBarText: "Errore imprevisto"

                    });
                    delete this.cancelTokenSources[protocolsService.getProtocolsUor.name];

                });


        }
    }

    updateContextMenuDashboard = (ev, item) => {
        const menuItems: IContextualMenuItem[] = [];

        let prot: IProtocol = { visibilita: [{ tipologia: Visibility_Type.Proprietario, uor: { id: this.props.currentUor!.id } }] };
        const { pageType, match, currentUser } = this.props;
        let aooId: number = Number(match.params['aooId']);

        menuItems.push(
            {
                key: 'open',
                text: 'Apri documento',
                iconProps: { iconName: 'Document' },
                onClick: () => {
                    this.navigate(ev, item);
                    this.onHideContextualMenu();
                }

            }
        );


        if (item.hasAttachments) {
            menuItems.push({
                key: 'downloadDocument',
                text: 'Scarica',
                iconProps: { iconName: 'DownloadDocument' },
                split: true,
                onClick: () => {
                    this.props.onDownloadProtocolDocumentClick();
                    this.onHideContextualMenu();
                },
                subMenuProps: {
                    items: [
                        {
                            key: 'downloadAll',
                            text: 'Scarica tutto',
                            iconProps: { iconName: 'Download' },
                            onClick: () => {
                                this.props.onDownloadAllButtonClick();
                                this.onHideContextualMenu();
                            }
                        },
                    ],
                }

            });

        }
        else {
            menuItems.push({
                key: 'downloadDocument',
                text: 'Scarica',
                iconProps: { iconName: 'DownloadDocument' },
                onClick: () => {
                    this.props.onDownloadProtocolDocumentClick();
                    this.onHideContextualMenu();
                }
            });
        }



        // ricavo le uor in cui l'utente corrente ha ruolo Operatore
        const uorIdWhereUserIsOperatore = currentUser?.ruoliUorContext.reduce((a: number[], o) => (o.aooId === aooId && o.ruoloNome === "Operatore" && a.push(o.uorId), a), []) ?? [];

        // in questo caso non va bene utilizzare abilityBuild perchè verifica se l'utente può eseguire
        // l'azione solo nella uor corrente, mentre l'utente può scegliere in quale uor
        // creare il protocollo

        if (uorIdWhereUserIsOperatore.length > 0) {
            menuItems.push(
                {
                    key: 'createFrom',
                    text: 'Crea da',
                    iconProps: { iconName: 'Copy' },
                    onClick: () => {
                        this.props.createProtocolFromHandler!();
                        this.onHideContextualMenu();
                    }
                }
            )
        }
        if (pageType === 'drafts' && abilityBuild.can('deleteDraft', subject('IProtocol', prot))
            && (this.state.selectedProtocol!.statoProtocollo === Protocol_State.InCreazione
                || this.state.selectedProtocol!.statoProtocollo === Protocol_State.InCreazioneDaMail)) {
            menuItems.push(
                {
                    key: 'deleteDraft',
                    text: 'Elimina bozza',
                    iconProps: { iconName: 'Delete' },
                    onClick: () => {
                        this.props.deleteDraftHandler!();
                        this.onHideContextualMenu();
                    }
                }
            )
        }

        return menuItems;
    }

    updateCommandBarItems = () => {
        const newFiltriCommandBarItems: ICommandBarItemProps[] = [];

        newFiltriCommandBarItems.push(
            {
                key: 'filtri',
                commandBarButtonAs: () => (

                    <CustomCommandBarButton
                        text='Filtri'
                        key='Filtri'
                        iconPropsFontAwesome={{ icon: ['far', 'filter'] }}
                        onClick={this.onFiltriClick}
                    />

                )
            }
        );

        if (this.state.queryCriteria.filters.length > 0) {
            newFiltriCommandBarItems.push({
                key: 'resetFiltri',
                commandBarButtonAs: () => (
                    <CustomCommandBarButton
                        text='Reset filtri'
                        key='resetFiltri'
                        iconPropsFontAwesome={{ icon: ['fal', 'filter-slash'] }}
                        onClick={this.resetSearchHandler}
                    />
                )
            });
        }

        newFiltriCommandBarItems.push(
            {
                key: 'aggiornaAreaDiLavoro',
                text: 'Aggiorna',
                iconProps: { iconName: 'Refresh' },
                onClick: this.onAggiornaClick
            },
        );


        this.setState({
            filtriCommandBarItems: newFiltriCommandBarItems
        });
    }

    onFiltriClick = () => {
        this.setState({ activePanel: 'search' });
    }

    openSummaryIAPanel = (item: IProtocol) => {
        const { location, match } = this.props;
        const aooId = Number(match.params['aooId']);
        const parsed = queryString.parse(location.search);
        const uorId = parsed.uorId ? Number(parsed.uorId) : undefined;

        const currentItem =
            this.state.items.find((el) => el && el.protocolId === item.protocolId) ?? item;

        this.setState({
            activePanel: 'summaryIA',
            summaryIA: currentItem.summaryIA ?? undefined,
            isLoadingSummaryIA: !currentItem.summaryIA,
            calloutTargetId: `summary-ia-${item.protocolId}` 
        });

        if (currentItem.summaryIA || !currentItem.hasSummaryIA) return;

        this.setState({ isLoadingSummaryIA: true, summaryIA: undefined });
        protocolsService.getSummaryIA(aooId, uorId, item.protocolId!)
            .then(summaryIA => {
                this.setState((prev) => ({
                    summaryIA,
                    isLoadingSummaryIA: false,
                    items: prev.items.map((el) =>
                        el && el.protocolId === item.protocolId ? { ...el, summaryIA: summaryIA } : el
                    ),
                }));
            })
            .catch(error => {
                this.setState({
                    isLoadingSummaryIA: false
                });

                if (axios.isCancel(error)) {
                    //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                    console.log(error.message);
                } else if (!error.isErrorShown) {
                    toastRef.current?.show({ severity: 'error', summary: 'Attezione', detail: `Impossibile leggere l'elaborazione IA`, life: 5000 });

                } else {
                    throw error;
                }

            });
    };

    // Click su cerca del panel laterale
    submitSearchPanelHandler = (searchFormFields: IField[]) => {

        let { queryCriteria } = this.state;
        let touchedFields: IField[] = searchFormFields.filter((el: IField) => el.touched && el.internalValue);
        let fixedFields = AppUtilities.fixFieldsValueForSearchEFSubmit([...touchedFields]);

        let currentQueryCriteria: IQueryCriteriaEF = {
            ...queryCriteria,
            pageNumber: 1,
            filters: [...fixedFields]
        };

        this.setState({
            activePanel: 'none',
            isLoadingProtocols: true,
            items: [],
            queryCriteria: currentQueryCriteria
        }, () => {
            this.getProtocolli();
            this.updateCommandBarItems()
        })
    }


    onAggiornaClick = () => {
        let { queryCriteria } = this.state;


        let currentQueryCriteria: IQueryCriteriaEF = { ...queryCriteria, pageNumber: 1 };

        this.setState({
            isLoadingProtocols: true,
            items: [],
            queryCriteria: currentQueryCriteria
        }, () => {
            this.getProtocolli();
            this.updateCommandBarItems()
        })

    }

    //metodo per resettare la ricerca
    resetSearchHandler = () => {
        let { queryCriteria } = this.state;

        let currentQueryCriteria: IQueryCriteriaEF = { ...queryCriteria, pageNumber: 1, filters: [] };

        this.protocolSelection.setAllSelected(false);

        this.setState({
            isLoadingProtocols: true,
            items: [],
            queryCriteria: currentQueryCriteria
        }, () => {
            this.getProtocolli();
            this.updateCommandBarItems()
        })

    }


    // metodi gestione context menu 
    onShowContextualMenu = (item, index, ev) => {
        ev.preventDefault();

        const menuItems = this.updateContextMenuDashboard(ev, item);
        this.setState({ contextMenuItems: menuItems, showContextualMenu: true, contextMenuPosition: ev });
    };


    onHideContextualMenu = () => {
        this.setState({ contextMenuItems: undefined, showContextualMenu: false });
    };

    dismissSearchPanel = (ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined) => {
        ev?.preventDefault();
        ev?.stopPropagation();
        this.setState({ activePanel: 'none' })
    }

    dismissSummaryIACallout = (ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined) => {
        ev?.preventDefault();
        ev?.stopPropagation();
        this.setState({ activePanel: 'none', calloutTargetId: undefined, summaryIA: undefined })
    }

    dismissMessageBar = () => {
        this.setState({ messageBarIsVisible: false })
    }

    checkUor() {
        const parsedQueryString = queryString.parse(this.props.location.search);
        let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

        if (uorId) {
            return true;
        }
        else if (this.props.currentAoo) {

            this.props.history.push({ pathname: `/${this.props.currentAoo.id}/ricerca` });
            return false;

        }
        else {

            return false;

        }
    }

    setColumns = (): IColumn[] => {

        const { pageType, tuttiIProtocolliViewFields } = this.props;
        let isDraftsPage = pageType === 'drafts';
        let isTodayPage = pageType === 'today';

        let fields: IField[] = [...tuttiIProtocolliViewFields!];

        const excludedInternalNames = [
            'ID',
            'Title',
            'Protocollo',
            'Proprietario',
            'CopiaConoscenza',
            'Inoltro',
            'Visibilita',
            ...(isDraftsPage ? ['DataProtocollo'] : [])
        ];

        const _fields = fields.filter(
            f => !f.system && !excludedInternalNames.includes(f.internalName)
        );

        let newColumns: IColumn[] = [
            {
                key: 'visibilita',
                name: 'visibilita',
                fieldName: 'visibilita',
                isIconOnly: true,
                styles: iconHeaderStyles,
                minWidth: 6,
                maxWidth: 6,
                onRenderField: this.onRenderVisibilitaField,
            },
            {
                key: 'hasAttachments',
                name: 'hasAttachments',
                fieldName: 'hasAttachments',
                isIconOnly: true,
                styles: iconHeaderStyles,
                minWidth: 7,
                maxWidth: 7,
                onRenderField: this.onRenderAttachmentField,
                onRenderHeader: () => {
                    return <Icon iconName="Attach" className={classNames.iconFieldHeader} />
                }
            }
        ];
        if (isTodayPage) {
            newColumns.push({
                key: 'statoProtocolloIcon',
                name: 'statoProtocolloIcon',
                fieldName: 'StatoProtocollo',
                isIconOnly: true,
                styles: iconHeaderStyles,
                minWidth: 9,
                maxWidth: 9,
                onRenderField: this.onRenderStatoProtocolloField,
                onRenderHeader: () => {
                    return <FontAwesomeIcon icon={{ prefix: 'fal', iconName: 'file-slash' }} className={classNames.fileIconHeaderIcon} />
                }
            })
        }
        if (isDraftsPage && abilityBuild.can('use', subject('IFeature', { key: 'IAAssistant', enabled: true }))) {
            newColumns.push({
                key: 'hasSummaryIAIcon',
                name: 'hasSummaryIAIcon',
                fieldName: 'hasSummaryIAIcon',
                isIconOnly: true,
                styles: iconHeaderStyles,
                minWidth: 9,
                maxWidth: 9,
                onRenderField: this.onRenderHasSummaryIAField,
                onRenderHeader: () => {
                    return <FontAwesomeIcon icon={{ prefix: 'fal', iconName: 'microchip-ai' }} className={classNames.fileIconHeaderIcon} />
                }
            })
        }
        if (!isDraftsPage) {
            newColumns.push({
                key: 'annotazione',
                name: 'annotazione',
                fieldName: 'annotazione',
                isIconOnly: true,
                styles: iconHeaderStyles,
                minWidth: 7,
                maxWidth: 7,
                onRenderField: this.onRenderAnnotazioneField,
                onRenderHeader: () => {
                    return <Icon iconName="Message" className={classNames.fileIconHeaderIcon} />
                },
            });
        }
        newColumns.push({
            key: 'Protocollo',
            name: 'Protocollo',
            fieldName: 'Protocollo',
            minWidth: isDraftsPage ? 140 : 110,
            maxWidth: isDraftsPage ? 140 : 110,
            isResizable: true,
        });

        _fields.forEach(el => {
            const fieldFullProperties = this.props.tuttiIProtocolliViewFields?.find(it => it.internalName === el.internalName);
            const field = fieldFullProperties ? { ...fieldFullProperties } : { ...el };
            let col: IColumn = {
                key: field.internalName,
                fieldName: field.internalName,
                name: field.displayName,
                minWidth: 150,
                isResizable: true,
                ...field
            };
            if (field.internalName === 'DataProtocollo' || field.internalName === 'StatoProtocollo') {
                col.maxWidth = 110;
                col.minWidth = 110;
            } else if (field.internalName === "TipoProtocollo") {
                col.maxWidth = 140;
                col.minWidth = 140;
            }
            newColumns.push(col);
        });
        /// Aggiungo una colonna vuota in coda alla tabella, è necessaria per consentire l'allineamneto tra
        /// l'header e i contenuti della tabella 
        if (!this.props.isMobile) {
            newColumns.push(
                {
                    key: 'empty',
                    name: 'empty',
                    fieldName: 'empty',
                    isIconOnly: true,

                    className: classNames.emptyColumn,
                    headerClassName: classNames.emptyColumn,
                    minWidth: 1,
                    maxWidth: 1,
                    onRender: (item) => {

                    },
                },

            );
        }
        return newColumns;

    }
    onRenderItemColumn = (protocol?: IProtocol, index?: number | undefined, column?: IColumn): React.ReactNode => {
        let fieldName = column?.fieldName;

        if (!protocol || !fieldName) {
            return this.buildDefaultCellRenderData(this.EMPTY_VALUE);
        }

        if (fieldName === "Protocollo") {
            return this.buildProtocolCellRenderData(protocol);
        }

        if (fieldName === "StatoProtocollo") {
            return this.buildProtocolStatusCellRenderData(protocol);
        }

        const fieldValue = protocol.fields?.find(f => f.internalName === fieldName);
        if (!fieldValue) {
            return this.buildDefaultCellRenderData(this.EMPTY_VALUE);
        }

        const fieldForDisplay = {
            ...column,
            internalValue: fieldValue.internalValue
        } as IField;

        const displayValue = AppUtilities.getDisplayValueFromFieldControlType(fieldForDisplay) || this.EMPTY_VALUE;

        return this.buildDefaultCellRenderData(displayValue);

    }

    buildDefaultCellRenderData = (value: string): React.ReactNode => {
        const tooltipProps = {
            content: value,
            styles: tooltipHostStyles,
            overflowMode: TooltipOverflowMode.Self
        };
        return (
            <TooltipHost {...tooltipProps}>
                {value}
            </TooltipHost>
        );
    };


    buildProtocolCellRenderData = (protocol: IProtocol): React.ReactNode => {
        let protocolText: string = AppUtilities.GetProtocolText(protocol);

        const isDraft =
            protocol.statoProtocollo === Protocol_State.InCreazione ||
            protocol.statoProtocollo === Protocol_State.InCreazioneDaMail;

        const longDate = isDraft ? AppUtilities.FormatLongDateTime(protocol.rowCreatedAt) : null;
        const shortDate = isDraft ? AppUtilities.FormatFriendlyShortDateTime(protocol.rowCreatedAt) : null;

        const tooltipText = isDraft
            ? longDate ? `Bozza creata il: ${longDate}` : `Bozza`
            : protocolText;

        const linkText = isDraft
            ? shortDate ? `Bozza - ${shortDate}` : "Bozza"
            : protocolText;

        const tooltipProps = isDraft && longDate
            // tooltip sempre visibile per le bozze, con data completa se disponibile
            ? { content: tooltipText }
            // tooltip visibile solo in caso di overflow
            : {
                content: tooltipText,
                styles: tooltipHostStyles,
                overflowMode: TooltipOverflowMode.Self
            };
        return (
            <TooltipHost {...tooltipProps}>
                <Link key={`link-protocol-${protocol.protocolId}`} onClick={(ev) => this.navigate(ev, protocol)} >
                    {linkText}
                </Link>
            </TooltipHost>
        );

    }
    buildProtocolStatusCellRenderData = (protocol: IProtocol): React.ReactNode => {
        let displayValue: string = !protocol.statoProtocollo ? "-" : Protocol_State_Label.get(protocol.statoProtocollo) ?? "-";

        const isMailDraft = protocol.statoProtocollo === Protocol_State.InCreazioneDaMail;
        if (isMailDraft) {
            const longDate = AppUtilities.FormatLongDateTime(protocol.dataMail);
            const shortDate = AppUtilities.FormatShortDateTime(protocol.dataMail);

            const tooltipProps = {
                content: longDate ? `${displayValue} del: ${longDate}` : displayValue
            };
            return (
                <TooltipHost {...tooltipProps}>
                    <div>{displayValue}</div>
                    <div className={classNames.xSmallText}>{shortDate}</div>
                </TooltipHost>
            );
        }

        return this.buildDefaultCellRenderData(displayValue);
    }

    navigate = (ev, item?: IProtocol) => {
        ev?.preventDefault();
        ev?.stopPropagation();
        if (item && item.protocolId) {
            this.props.setProtocol(item!);
            //aggiunge gli zeri prima del numero
            const zeroPad = (num, places) => String(num).padStart(places, '0');
            let protocolnumber = zeroPad(item.numeroProtocollo, 8) + '-' + item.annoProtocollo;
            let path;
            switch (item.statoProtocollo) {
                case Protocol_State.Protocollato:
                case Protocol_State.Acquisito:
                case Protocol_State.Annullato:
                    path = `/${this.props.currentAoo!.id}/${item.protocolId}/${protocolnumber}`;
                    break;
                case Protocol_State.Allocato:
                    path = `/${this.props.currentAoo!.id}/allocated/${item.protocolId}/${protocolnumber}`;
                    break;
                case Protocol_State.InCreazione:
                case Protocol_State.InCreazioneDaMail:
                    path = `/${this.props.currentAoo!.id}/edit/${item.protocolId}`;
                    break;

            }
            this.props.history.push({ pathname: path, search: this.props.location.search });
        }
    }

    onColumnHeaderClick = (ev: React.MouseEvent<HTMLElement> | undefined, column: IColumn | undefined): void => {
        ev?.preventDefault();
        ev?.stopPropagation();
        const { columns, queryCriteria } = this.state;

        if (column) {
            let newIsSortedDescending = !column.isSortedDescending;
            let newColumns = columns.map((col: IColumn) => {
                if (col.key === column.key) {
                    col.isSortedDescending = newIsSortedDescending;
                    col.isSorted = true;
                } else {
                    col.isSorted = false;
                    col.isSortedDescending = true;
                }
                return col;
            });

            let sortDirection = newIsSortedDescending ? SortEF_Direction.Descending : SortEF_Direction.Ascending;
            let currentQueryCriteria: IQueryCriteriaEF = {
                ...queryCriteria,
                pageNumber: 1,
                sorts: [{ fieldName: column.key, sortDirection: sortDirection }]
            }

            this.setState({
                isLoadingProtocols: true,
                columns: newColumns,
                items: [],
                queryCriteria: currentQueryCriteria
            }, () => {
                this.getProtocolli();
                //localStorage.setItem(`columns_${aooId}_${uorId}`, JSON.stringify(newColumns));

            })
        }
    }

    onRenderAttachmentField: IRenderFunction<IDetailsColumnFieldProps> = (columnProps, defaultRender) => {
        let iconContent: any = (<React.Fragment></React.Fragment>);
        if (columnProps && columnProps.item && columnProps.item.hasAttachments) {
            iconContent = (
                <Icon iconName="Attach" style={{ fontSize: 16 }} />
            );

        }
        return (
            <div key={`attachment-protocol-${columnProps!.item!.id}`} className={classNames.iconField} >
                <TooltipHost content="Allegato">
                    {iconContent}
                </TooltipHost>
            </div>
        );
    }

    onRenderAnnotazioneField: IRenderFunction<IDetailsColumnFieldProps> = (columnProps, defaultRender) => {
        let iconContent: any = (<React.Fragment></React.Fragment>);
        if (columnProps && columnProps.item && columnProps.item.hasNotes) {
            iconContent = (
                <Icon iconName="Message" style={{ fontSize: 16 }} />
            );

        }
        return (
            <div key={`annotation-protocol-${columnProps!.item!.id}`} className={classNames.iconField} >
                <TooltipHost content="Annotazione">
                    {iconContent}
                </TooltipHost>
            </div>
        );
    }

    onRenderStatoProtocolloField: IRenderFunction<IDetailsColumnFieldProps> = (columnProps, defaultRender) => {
        let iconContent: any = (<React.Fragment></React.Fragment>);
        if (columnProps && columnProps.item && columnProps.item.statoProtocollo === Protocol_State.Annullato) {
            iconContent = (
                <FontAwesomeIcon icon={{ prefix: 'fal', iconName: 'file-slash' }} style={{ fontSize: 16 }} />
            );

        }
        return (
            <div key={`state-protocol-${columnProps!.item!.id}`} className={classNames.iconField} >
                <TooltipHost content="Annullato">
                    {iconContent}
                </TooltipHost>
            </div>
        );
    }
    onRenderHasSummaryIAField: IRenderFunction<IDetailsColumnFieldProps> = (columnProps, defaultRender) => {
        let iconContent: any = (<React.Fragment></React.Fragment>);
        if (columnProps && columnProps.item && columnProps.item.hasSummaryIA) {
            iconContent = (
                <FontAwesomeIcon id={`summary-ia-${columnProps!.item!.id}`}
                    icon={{ prefix: 'fal', iconName: 'microchip-ai' }}
                    style={{ fontSize: 16, cursor: 'pointer' }}
                    onClick={() => this.openSummaryIAPanel(columnProps!.item!)} />
            );

        }
        return (
            <div key={`wrap-summary-ia-${columnProps!.item!.id}`} className={classNames.iconField} >
                <TooltipHost content="Analisi IA disponibile">
                    {iconContent}
                </TooltipHost>
            </div>
        );
    }
    onRenderProtocolloField: IRenderFunction<IDetailsColumnFieldProps> = (columnProps, defaultRender) => {
        let iconContent: any = (<React.Fragment></React.Fragment>);
        if (columnProps && columnProps.item && columnProps.item.statoProtocollo === Protocol_State.Annullato) {
            iconContent = (
                <FontAwesomeIcon icon={{ prefix: 'fal', iconName: 'file-slash' }} style={{ fontSize: 16 }} />
            );

        }
        return (
            <div key={`state-protocol-${columnProps!.item!.id}`} className={classNames.iconField} >
                <TooltipHost content="Annullato">
                    {iconContent}
                </TooltipHost>
            </div>
        );
    }

    onRenderVisibilitaField: IRenderFunction<IDetailsColumnFieldProps> = (columnProps, defaultRender) => {
        if (columnProps && columnProps.item && columnProps.item.visibilita) {
            const arrayVisibilita = columnProps.item.visibilita;
            const visibilitaObj = arrayVisibilita.find(obj => obj.uor.id === this.props.currentUor!.id);
            let protocolId = columnProps.item.id;
            switch (visibilitaObj?.tipologia) {

                case Visibility_Type.Proprietario:
                    return (<TableIconProprietario key={`visibilita-protocol-${protocolId}`} />);

                case Visibility_Type.Inoltro:
                    return (<TableIconInoltro key={`visibilita-protocol-${protocolId}`} />);

                case Visibility_Type.CopiaConoscenza:
                    return (<TableIconCopiaConoscenza key={`visibilita-protocol-${protocolId}`} />);

                case Visibility_Type.Visibilita:
                    return (<TableIconVisibilita key={`visibilita-protocol-${protocolId}`} />);
                default:
                    return <div className={classNames.iconField} ></div>;

            }

        }
        return <div className={classNames.iconField} ></div>;
    }



    onRenderDetailsHeader = (detailsHeaderProps) => {
        const detailsListHeadrerStyles: Partial<IDetailsListStyles> = {

            root: { boxSizing: 'content-box !important' }

        };
        return (
            <DetailsHeader
                {...detailsHeaderProps}
                styles={detailsListHeadrerStyles}
            />
        );
    }

    onRenderRow: IDetailsListProps['onRenderRow'] = props => {
        const customStyles: Partial<IDetailsRowStyles> = {};
        if (props) {
            customStyles.cell = { display: 'flex', alignItems: 'center', maxHeight: 42 };

            return <DetailsRow {...props} styles={customStyles} />;
        }
        return null;
    };




    private removeNullPlaceholders = (items: (IProtocol | null)[]) =>
        items.filter((item): item is IProtocol => item !== null);

    public render() {
        return (

            <React.Fragment>
                <div className="protocols-table-component">
                    <CircleLoader loaderClass='loader-large' loading={this.state.isLoadingProtocols} />

                    {this.state.messageBarIsVisible &&
                        <MessageBar
                            messageBarType={this.state.messageBarType}
                            isMultiline={false}
                            onDismiss={this.dismissMessageBar}
                            dismissButtonAriaLabel="Close">{this.state.messageBarText}</MessageBar>
                    }

                    {this.props.showFilterCommandBar &&

                        <div className={classNames.filtriCommandBar} >
                            <CommandBar
                                overflowButtonProps={overflowProps}
                                items={this.state.filtriCommandBarItems}
                                styles={filtriCommandBarStyles}

                            />
                        </div>
                    }

                    {this.state.items.length > 0 &&
                        <DetailsList
                            className="with-empty-column"
                            styles={detailsListStyles}
                            items={this.state.items}
                            columns={this.state.columns}
                            onRenderRow={this.onRenderRow}
                            onRenderItemColumn={this.onRenderItemColumn}
                            onRenderDetailsHeader={this.onRenderDetailsHeader}
                            onRenderMissingItem={this.onRenderMissingItem}
                            layoutMode={DetailsListLayoutMode.justified}
                            selection={this.protocolSelection}
                            selectionPreservedOnEmptyClick={true}
                            selectionMode={SelectionMode.single}
                            checkboxVisibility={CheckboxVisibility.onHover}
                            onItemContextMenu={this.onShowContextualMenu}

                        />
                    }
                    {this.state.items.length === 0 && !this.state.isLoadingProtocols &&

                        <Text block style={{ padding: 25 }}>Non ci sono protocolli.</Text>
                    }

                    <ContextualMenu
                        items={this.state.contextMenuItems!}
                        hidden={!this.state.showContextualMenu}
                        target={this.state.contextMenuPosition}
                        onItemClick={this.onHideContextualMenu}
                        onDismiss={this.onHideContextualMenu}
                    />

                    <SearchPanel
                        isOpen={this.state.activePanel === 'search'}
                        initialSearchFields={initialSearchFields}
                        onDismiss={this.dismissSearchPanel}
                        onApply={this.submitSearchPanelHandler}
                    />

                    <SummaryIACallout
                        isOpen={this.state.activePanel === 'summaryIA'}
                        targetId={this.state.calloutTargetId}
                        summaryIA={this.state.summaryIA}
                        isLoading={this.state.isLoadingSummaryIA}
                        onDismiss={this.dismissSummaryIACallout}
                    />
                </div>
            </React.Fragment>


        );
    }

}
export default connector(withRouter(ProtocolsTable));


